import { WhitelabelType } from '@/Enums/Whitelabels/WhitelabelType.enum';
import { IControlOption } from '@/Interfaces/ControlOption.interface';
import {
  IParsedWhitelabelWithRelations,
  IWhitelabelWithRelations,
} from '@/Interfaces/Whitelabels/Whitelabel.interface';
import { parseWhitelabelsWithRelations } from '../Whitelabels';
import { ribeyeAdvertiserMapper } from '../advertisers/advertiserMappers.helpers';

export const formatWhitelabelsResponse = (
  responseWhitelabels: IWhitelabelWithRelations[],
): { whitelabels: IParsedWhitelabelWithRelations[]; orgs: IParsedWhitelabelWithRelations[] } => {
  const whitelabels: IParsedWhitelabelWithRelations[] = [];
  const orgs: IParsedWhitelabelWithRelations[] = [];
  parseWhitelabelsWithRelations<IControlOption>(responseWhitelabels, ribeyeAdvertiserMapper, null, true).forEach(wl =>
    wl.type === WhitelabelType.Organization ? orgs.push(wl) : whitelabels.push(wl),
  );
  return { whitelabels, orgs };
};

export const getOrgWhitelabels = (
  orgId: number,
  whitelabels: IParsedWhitelabelWithRelations[],
): IParsedWhitelabelWithRelations[] => {
  return whitelabels.filter(wl => wl.parentId === orgId);
};
